// extracted by css-extract-rspack-plugin
export default {"moreFiltersButton":"_fff024f"};